import { colors } from '@/constants';
import styled from 'styled-components';

export const CalendarContainer = styled.div<{ $scrolled?: boolean }>`
  display: flex;
  width: 100%;
  position: sticky;
  top: ${({ $scrolled }) => ($scrolled ? '0px' : '50px')};
  flex-direction: column;
  padding: 12px;
  padding-bottom: 0;
  gap: 12px;
  background-color: ${colors.gray.gray10};
  box-shadow: 0px 2px 4px -2px rgba(0, 0, 0, 0.1);
`;

export const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: start;
  flex-direction: row;
  gap: 4px;
`;

export const TotalsRow = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  gap: 4px;

  span {
    font-size: 12px !important;
  }
`;

export const Col = styled.div`
  width: max-content;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Title = styled.span<{ $textalign?: 'start' | 'end' }>`
  font-family: Roboto, sans-serif;
  color: ${colors.grey3};
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: ${(i) => i.$textalign};
`;

export const Date = styled.span<{ color?: string }>`
  color: ${(props) => props.color || colors.brand.grafite};
  font-weight: 700;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  line-height: 16px;
`;

export const Total = styled.span<{ color?: string }>`
  color: ${(props) => props.color || colors.brand.grafite};
  font-weight: 700;
  font-size: 14px;
  text-align: end;
  margin-left: 6px;
  font-family: Roboto, sans-serif;
  line-height: 16px;
`;
